import { GetStaticPaths, GetStaticProps } from 'next';
import { getLocalePaths } from '@i18n';
import RulesMarkdown from '@components/pages/rules';

import WithRoles, { rolesEnum } from '@HOCs/WithRole';

const Rules: React.FC = () => {
    return <RulesMarkdown />;
};

export default WithRoles(Rules, [rolesEnum.guest]);

export const getStaticProps: GetStaticProps = async ({ params }) => {
    return { props: { locale: params?.locale } };
};

export const getStaticPaths: GetStaticPaths = async () => {
    return { paths: getLocalePaths(), fallback: false };
};
